import type {
  CertificatePolicy,
  AuthenticationType,
  KeyType,
  HashType,
} from "../../../shared/models/certificate_policy";
import { post } from "aws-amplify/api";
import { createDataStore } from "../lib/data_store";
import { API_NAME } from "../lib/amplify";
import { extractApiError } from "../lib/api_error";

const certificatePolicyStore = createDataStore<
  CertificatePolicy[] | undefined
>();

export const useCertificatePolicies = certificatePolicyStore.useDataSuspense;
export const setCertificatePolicies = certificatePolicyStore.setData;

export async function addCertificatePolicy(data: {
  name: string;
  authenticationType: AuthenticationType;
  durationDays: number;
  autoRenew: boolean;
  keyType: KeyType;
  keyLength: number;
  hashType: HashType;
}): Promise<CertificatePolicy> {
  try {
    const { body } = await post({
      apiName: API_NAME,
      path: "/create-certificate-policy",
      options: { body: data },
    }).response;
    const policy = (await body.json()) as unknown as CertificatePolicy;
    certificatePolicyStore.updateData((current) => [
      ...(current ?? []),
      policy,
    ]);
    return policy;
  } catch (err) {
    throw new Error(await extractApiError(err));
  }
}

export async function deleteCertificatePolicy(id: string): Promise<void> {
  try {
    await post({
      apiName: API_NAME,
      path: "/delete-certificate-policy",
      options: { body: { id } },
    }).response;
  } catch (err) {
    throw new Error(await extractApiError(err));
  }

  certificatePolicyStore.updateData((current) =>
    (current ?? []).filter((p) => p.id !== id),
  );
}
